import React, { useEffect, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useNavigate, Link } from "react-router-dom";
import { SIGNUP_PORTAL_USER_MUTATION } from "./graphql/signupPortalUser";

interface LegacyUser {
  id: number;
  name: string;
  login: string;
  email: string;
verificationToken: string;
  system: "REDHAWK" | "SIMWB";

  // RedHawk role
  user_type_id?: string | null;

  // SIMWB role
  user_type?: string | null;

  // SIMWB name fields, optional
  first_name?: string | null;
  last_name?: string | null;
}

interface SignupData {
  signupPortalUser: {
    id: number;
    name: string;
    email: string;
    login: string;
  };
}

interface SignupVars {
  name: string;
  email: string;
  login: string;
  password: string;
  verificationToken: string;
}

const Signup: React.FC = () => {
  const navigate = useNavigate();

  const [legacyUser, setLegacyUser] = useState<LegacyUser | null>(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    login: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("legacyUser");

    if (!storedUser) {
      navigate("/");
      return;
    }

    const parsedUser: LegacyUser = JSON.parse(storedUser);

    setLegacyUser(parsedUser);

    setFormData((prev) => ({
      ...prev,
      name: parsedUser.name || "",
      email: parsedUser.email || "",
      login: parsedUser.login || "",
    }));
  }, [navigate]);

const [signupUser, { loading, error }] = useMutation<
  SignupData,
  SignupVars
>(SIGNUP_PORTAL_USER_MUTATION);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogout = () => {
    // Remove stored users
    localStorage.removeItem("legacyUser");
    localStorage.removeItem("user");

    // Clear state
    setLegacyUser(null);

    // Redirect back to login page
    navigate("/");
  };

 const handleSignup = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!legacyUser?.verificationToken) {
    alert("Legacy user verification missing. Please log in again.");
    navigate("/");
    return;
  }

  if (formData.password !== formData.confirmPassword) {
    alert("Passwords do not match");
    return;
  }

  const signupVariables: SignupVars = {
  name: formData.name,
  email: formData.email,
  login: formData.login,
  password: formData.password,
  verificationToken: legacyUser.verificationToken,
};

  

  try {
    const { data } = await signupUser({
      variables: signupVariables,
    });

    if (data?.signupPortalUser) {
      localStorage.setItem("user", JSON.stringify(data.signupPortalUser));

      localStorage.removeItem("legacyUser");

      alert("Portal account created successfully");

      navigate("/portal");
    }
  } catch (err) {
    console.error(err);
    alert("Signup failed");
  }
};

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px",
        fontFamily: "Arial",
      }}
    >
      <h1>Create Portal Account</h1>

      {legacyUser && (
        <p style={{ color: "green" }}>
          Legacy account verified for {legacyUser.name}
        </p>
      )}

      <form
        onSubmit={handleSignup}
        style={{
          display: "inline-flex",
          flexDirection: "column",
          width: "300px",
        }}
      >
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <input
          type="text"
          name="login"
          placeholder="Username"
          value={formData.login}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Create New Portal Password"
          value={formData.password}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm New Portal Password"
          value={formData.confirmPassword}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <button
          type="submit"
          disabled={loading}
          style={buttonStyle}
        >
          {loading ? "Creating Account..." : "Create Portal Account"}
        </button>

        <button
          type="button"
          onClick={handleLogout}
          style={logoutButtonStyle}
        >
          Logout
        </button>

        {error && (
          <p style={{ color: "red", marginTop: "10px" }}>
            Failed to create account
          </p>
        )}

        <p style={{ marginTop: "15px" }}>
          Already have a portal account? <Link to="/">Login</Link>
        </p>
      </form>
    </div>
  );
};

const inputStyle: React.CSSProperties = {
  padding: "10px",
  margin: "8px 0",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

const buttonStyle: React.CSSProperties = {
  padding: "12px",
  marginTop: "10px",
  cursor: "pointer",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontSize: "16px",
};

const logoutButtonStyle: React.CSSProperties = {
  padding: "12px",
  marginTop: "10px",
  cursor: "pointer",
  background: "#dc3545",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontSize: "16px",
};

export default Signup;